import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import DroneParts from "../components/droneParts/DroneParts";
import { Header, Footer } from "../shared";

const DronePartsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <DroneParts />
      <Footer />
    </div>
  );
};

export default DronePartsPage;
